var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-users",
    "data-name": "Icon feather-users",
    transform: "translate(310.248 250.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20319",
    "data-name": "Path 20319",
    d: "M12.049,26.456V25.137A2.637,2.637,0,0,0,9.412,22.5H4.137A2.637,2.637,0,0,0,1.5,25.137v1.319",
    transform: "translate(0 -10.088)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20320",
    "data-name": "Path 20320",
    d: "M12.775,7.137A2.637,2.637,0,1,1,10.137,4.5,2.637,2.637,0,0,1,12.775,7.137Z",
    transform: "translate(-3.363)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20321",
    "data-name": "Path 20321",
    d: "M31.978,26.565V25.247A2.637,2.637,0,0,0,30,22.7",
    transform: "translate(-15.973 -10.197)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20322",
    "data-name": "Path 20322",
    d: "M24,4.695A2.637,2.637,0,0,1,24,9.8",
    transform: "translate(-12.61 -0.109)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/teamIcon.57973890b1d32c8bd837c9984c65d2b8.svg";
export { ForwardRef as ReactComponent };